import script from "./home-header-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./home-header-menu.vue?vue&type=script&setup=true&lang=js"

import "./home-header-menu.vue?vue&type=style&index=0&id=05f6ab76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05f6ab76"]])

export default __exports__